import React, { useState } from 'react';
import {
    IconButton,
    Menu,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    Select,
    FormControl,
    InputLabel,
    MenuItem as SelectMenuItem,
    TextField,
    Grid, Typography
} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {isMobile} from "../App/utils";
import {parseTS} from "../utils";


const transactionSubjects = {
    paymentIntent: 'paymentIntent',
    kbId: 'kbId',
};


const getDynamicRefundReason = () => {
    const funnyReasons = [
        "Because My Cat Disapproved",
        "Thought It Was a Donut",
        "Because Mercury Is in Retrograde",
        "Realized I’m Saving for a Spaceship",
        "My Horoscope Said No",
        "Decided to Invest in Ice Cream Instead"
    ];

    const randomIndex = Math.floor(Math.random() * funnyReasons.length);

    return funnyReasons[randomIndex];
};

export const TransactionActionsMenu = ({ transaction, balance, onRefund, refunded }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [refundDialogOpen, setRefundDialogOpen] = useState(false);
    const [detailViewDialogOpen, setDetailViewDialogOpen] = useState(false);
    const [refundReason, setRefundReason] = useState('');
    const [customerReason, setCustomerReason] = useState('');

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleRefundClick = () => {
        setRefundDialogOpen(true);
        handleClose(); // Close the menu
    };

    const handleDetailViewClick = () => {
        setDetailViewDialogOpen(true);
        handleClose(); // Close the menu
    };

    const handleRefundClose = () => {
        setRefundDialogOpen(false);
        setRefundReason('');
    };

    const handleDetailViewClose = () => {
        setDetailViewDialogOpen(false);
    };

    const handleRefundConfirm = () => {
        onRefund(transaction.subjectId, refundReason, customerReason);
        handleRefundClose();
    };

    const menuItems = [];
    const timePass = Math.round((+new Date() - parseTS(transaction?.id)) / 1000);
    const tolerance = 300000;

    const refundable =  timePass < 60 * 60 * 24 * 30 && balance > 0
        && balance > (transaction?.amount - tolerance) && !refunded[transaction.subjectId]

    if (transaction.amount > 0 && transaction.subject === transactionSubjects.paymentIntent && refundable) {
        menuItems.push(<MenuItem key={'refund'} onClick={handleRefundClick}>Refund</MenuItem>);
    }
    // Add Detail View option
    menuItems.push(<MenuItem key={'detailView'} onClick={handleDetailViewClick}>View</MenuItem>);

    if (!menuItems?.length) return null;


    const buttonStyle = isMobile ? { backgroundColor: 'rgba(0, 0, 0, 0.05)', borderRadius: '50%', marginTop: '-16px', marginRight: '-4px' } : {};

    return (
        <div>
            <IconButton
                sx={buttonStyle}
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            {isMobile && <div style={{height: '8px'}}></div>}
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        maxHeight: 48 * 4.5,
                        width: '20ch',
                    },
                }}
            >
                {menuItems}
            </Menu>

            <Dialog open={refundDialogOpen} onClose={handleRefundClose} sx={{ '& .MuiDialog-paper': { minWidth: isMobile ? '300px' : '500px' } }}>
                <DialogTitle>Select Refund Reason</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth margin="normal">
                        <InputLabel>Reason</InputLabel>
                        <Select
                            value={refundReason}
                            label="Reason"
                            onChange={(e) => {
                                setRefundReason(e.target.value);
                                if (e.target.value !== 'requested_by_customer') {
                                    setCustomerReason('');
                                } else {
                                    setCustomerReason('Didn\'t meet my expectations');
                                }
                            }}
                        >
                            <SelectMenuItem value="duplicate">Duplicate</SelectMenuItem>
                            <SelectMenuItem value="fraudulent">Fraudulent</SelectMenuItem>
                            <SelectMenuItem value="requested_by_customer">Other</SelectMenuItem>
                        </Select>
                    </FormControl>
                    {refundReason === 'requested_by_customer' && (
                        <TextField
                            autoFocus
                            margin="dense"
                            id="customerReason"
                            label="Reason"
                            type="text"
                            fullWidth
                            multiline={true}
                            minRows={2}
                            variant="standard"
                            value={customerReason}
                            onChange={(e) => setCustomerReason(e.target.value)}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleRefundClose}>Cancel</Button>
                    <Button onClick={handleRefundConfirm} disabled={!refundReason || (refundReason === 'requested_by_customer' && !customerReason)} variant="contained" color="primary">Refund</Button>
                </DialogActions>
            </Dialog>


            {/* Detail View Dialog */}
            <Dialog open={detailViewDialogOpen} onClose={handleDetailViewClose} sx={{ '& .MuiDialog-paper': { minWidth: isMobile ? '300px' : '500px' } }}>
                <DialogTitle>Transaction Details</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        {Object.entries(transaction).map(([key, value]) => (
                            <Grid item xs={12} key={key}>
                                <Typography variant="body1">
                                    <strong>{key}:</strong> {key === 'amount' ? (value / 1000).toFixed(2) : value}
                                </Typography>
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDetailViewClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};